import { Grid, Skeleton, Typography } from '@mui/material'

import classes from './index.styles'

type IProps =
  | {
      isLoading: true
      label?: string
      value?: string | number | null
    }
  | {
      isLoading?: false
      label: string
      value: string | number | null
    }

const DeviceInfoItem = ({ label, value, isLoading }: IProps) => {
  return (
    <Grid container={true} size={{ xs: 12, sm: 6, md: 12, lg: 6 }} sx={classes.deviceInfoItem}>
      <Typography variant="body2" sx={classes.deviceInfoLabel}>
        {isLoading ? <Skeleton width={100} /> : label}
      </Typography>
      <Typography variant="body2" sx={classes.deviceInfoValue}>
        {isLoading ? <Skeleton width="100%" /> : value}
      </Typography>
    </Grid>
  )
}

export default DeviceInfoItem
